(function () {
  var SELECTOR = '[data-aw-staff-works]';
  var EVENT_NAME = 'aw:style-items-loaded';

  var applyItems = function (items) {
    var hasStyle = {};
    (items || []).forEach(function (item) {
      if (item && item.image && item.staffHandle) hasStyle[item.staffHandle] = true;
    });

    Array.prototype.forEach.call(document.querySelectorAll(SELECTOR), function (button) {
      var actions = button.parentNode;
      if (hasStyle[button.getAttribute('data-aw-staff-works')]) {
        button.removeAttribute('data-aw-staff-works');
        button.hidden = false;
        return;
      }
      button.remove();
      if (actions && !actions.children.length) actions.remove();
    });
  };

  var revealAll = function () {
    Array.prototype.forEach.call(document.querySelectorAll(SELECTOR), function (button) {
      button.removeAttribute('data-aw-staff-works');
      button.hidden = false;
    });
  };

  var init = function () {
    if (!document.querySelector(SELECTOR)) return;

    if (window.awStyleItems) {
      applyItems(window.awStyleItems);
      return;
    }
    if (!document.querySelector('[data-aw-style-grid]')) {
      revealAll();
      return;
    }
    document.addEventListener(EVENT_NAME, function (event) {
      applyItems(event.detail && event.detail.items);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
